function formatSelect2Option(option) {

	var format = $(option.element).data('format');

	return '<div class="' + format + '">' + option.text + '</div>';
}

$(function() {

	$(".configurator-button-product").click(function() {
		$('section.configurator').find( ".configurator__core").addClass('cf-visible');
		$('section.configurator').find( ".configurator__product").addClass('cf-visible');
		$('section.configurator').find( ".configurator__application").removeClass('cf-visible');
		$('section.configurator').find( ".configurator__pressure").removeClass('cf-visible');
		$('section.configurator').find( ".configurator__default").addClass('hide');
		$('section.configurator').find( ".button_submit").removeClass('hide');
		$('section.configurator').find( 'input[name="search_type"]').val('product');
		$('section.configurator').find('select[name="pressure_simbol"]').select2("val", "");
		$('section.configurator').find('input[name="pressure_value"]').val(null);
		$('section.configurator').find('select[name="pressure_type"]').select2("val", "");
		$('section.configurator').find('select[name="flow_simbol"]').select2("val", "");
		$('section.configurator').find('input[name="flow_value"]').val(null);
		$('section.configurator').find('select[name="flow_type"]').select2("val", "");
	});

	$(".configurator-button-application").click(function() {
		$('section.configurator').find( ".configurator__core").addClass('cf-visible');
		$('section.configurator').find( ".configurator__application").addClass('cf-visible');
		$('section.configurator').find( ".configurator__product").removeClass('cf-visible');
		$('section.configurator').find( ".configurator__pressure").removeClass('cf-visible');
		$('section.configurator').find( ".configurator__default").addClass('hide');
		$('section.configurator').find( ".button_submit").addClass('hide');
		$('section.configurator').find( 'input[name="search_type"]').val('application');
		$('section.configurator').find('select[name="sm"]').select2("val", "");
		$('section.configurator').find('select[name="pressure_simbol"]').select2("val", "");
		$('section.configurator').find('input[name="pressure_value"]').val(null);
		$('section.configurator').find('select[name="pressure_type"]').select2("val", "");
		$('section.configurator').find('select[name="flow_simbol"]').select2("val", "");
		$('section.configurator').find('input[name="flow_value"]').val(null);
		$('section.configurator').find('select[name="flow_type"]').select2("val", "");
	});

	$(".configurator-button-pressure ").click(function() {
		$('section.configurator').find( ".configurator__core").addClass('cf-visible');
		$('section.configurator').find( ".configurator__pressure").addClass('cf-visible');
		$('section.configurator').find( ".configurator__application").removeClass('cf-visible');
		$('section.configurator').find( ".configurator__product").removeClass('cf-visible');
		$('section.configurator').find( ".configurator__default").addClass('hide');
		$('section.configurator').find( ".button_submit").removeClass('hide');
		$('section.configurator').find( 'input[name="search_type"]').val('pressure');
		$('section.configurator').find('select[name="sm"]').select2("val", "");
	});

	$('section.configurator').find(".button_close").click(function() {
		$('section.configurator').find( ".configurator__core").removeClass('cf-visible');
		$('section.configurator').find( ".configurator__product").removeClass('cf-visible');
		$('section.configurator').find( ".configurator__application").removeClass('cf-visible');
		$('section.configurator').find( ".configurator__pressure").removeClass('cf-visible');
		$('section.configurator').find( ".configurator__default").removeClass('hide');
		$('section.configurator').find( ".button_submit").removeClass('hide');
		$('section.configurator').find('select[name="sm"]').select2("val", "");
		$('section.configurator').find('select[name="pressure_simbol"]').select2("val", "");
		$('section.configurator').find('input[name="pressure_value"]').val(null);
		$('section.configurator').find('select[name="pressure_type"]').select2("val", "");
		$('section.configurator').find('select[name="flow_simbol"]').select2("val", "");
		$('section.configurator').find('input[name="flow_value"]').val(null);
		$('section.configurator').find('select[name="flow_type"]').select2("val", "");
	});


	$("select#sm").select2({
		placeholder: translation['Modello'],
		allowClear: true,

		formatResult: formatSelect2Option,
		formatSelection: formatSelect2Option,
		escapeMarkup: function(m) { return m; }

	});

	/**
	 * setta il tipo (modello o categoria) quando un utente selezione un valore della select
	 */
	$("select#sm").on("change", function(e, added, removed) {
		var element = $(e.added.element);

		$("#smtype").val(element.data('format'));
	});

	/* ==========================================
	scrollTop() >= 300
	Should be equal the the height of the header
	========================================== */

	$(window).scroll(function(){
	    if ($(window).scrollTop() >= 1) {
	        $('#header').addClass('fixed-header');
	        $('#content').addClass('fixed-header');
	    }
	    else {
	        $('#header').removeClass('fixed-header');
	        $('#content').removeClass('fixed-header');
	    }
	});

	$(document).delegate("li.dropdown [data-keepOpenOnClick]", "click", function(e) {
	    e.stopPropagation();
	});

















	/**
	 * setta un cookie
	 */
	function setCookie(cname, cvalue, exdays) {

	    var d = new Date();
	    d.setTime(d.getTime() + (exdays*24*60*60*1000));
	    var expires = "expires="+d.toUTCString();
	    document.cookie = cname + "=" + cvalue + "; " + expires +"; path=/";

	    return getCookie(cname);
	}

	/**
	 * ritorna il valore del cookie
	 */
	function getCookie(cname) {

	    var name = cname + "=";
	    var ca = document.cookie.split(';');
	    for(var i=0; i<ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0)==' ') c = c.substring(1);
	        if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
	    }
	    return "";
	}

	/**
	 * cancella il cookie
	 */
	function eraseCookie(name) {
	    setCookie(name,"",-1);
	}







	// /**
	//  * Promo Popup
	//  */
	// $('#promoPopupBG, #promoPopup button').on('click', function() {
	// 	$('#promoPopup').removeClass('showPopup');
	// });
	//
	// function promoPopup() {
	// 	if (!getCookie('promoPopup2024')) {
	// 	   setTimeout(function (args) {
	// 			$('#promoPopup').addClass('showPopup');
	// 			setCookie('promoPopup2024', 1, 1);
	// 		}, 1000);
	// 	}
	// }
	//
	//
	// function formatDateToYYYYMMDD(date) {
	// 	var year = date.getFullYear();
	// 	var month = ('0' + (date.getMonth() + 1)).slice(-2);
	// 	var day = ('0' + date.getDate()).slice(-2);
	// 	return year + '-' + month + '-' + day;
	// }
	//
	//
	// var startDate = new Date('2024-02-20');
	// var endDate = new Date('2024-03-15');
	// var currentDate = new Date();
	//
	// var formattedStartDate = formatDateToYYYYMMDD(startDate);
	// var formattedEndDate = formatDateToYYYYMMDD(endDate);
	// var formattedCurrentDate = formatDateToYYYYMMDD(currentDate);
	//
	// // console.log('Formatted Start Date: ' + formattedStartDate);
	// // console.log('Formatted End Date: ' + formattedEndDate);
	// // console.log('Formatted Current Date: ' + formattedCurrentDate);
	//
	//
	//
	// if (formattedCurrentDate >= formattedStartDate && formattedCurrentDate <= formattedEndDate) {
	// 	// console.log('popup started');
	// 	// setTimeout(function() {
	// 		promoPopup();
	// 		// console.log('popup added');
	// 	// }, 4000); // 4000 millisecondi (4 secondi)
	// } else {
	// 	console.log('no popup');
	// }





	// /**
	//  * modalEcobrass
	//  */
	// function modalEcobrass() {
	//     if (!getCookie('modalEcobrass_2024')) {
	//         setTimeout(function (args) {
	//             $('#temp-modal-video').modal('show');
	//             setCookie('modalEcobrass_2024', 1, 1);
	//         }, 1000);
	//     } else {
	//     	$('#temp-modal-video').modal('hide')
	//     }
	// }
	//
	// modalEcobrass();

	$('#promoPopupBG, #promoPopup button').on('click', function() {
		$('#promoPopup').removeClass('showPopup');
	});

	function promoPopup() {
		if (!getCookie('promoPopup2024')) {
		   setTimeout(function (args) {
				$('#promoPopup').addClass('showPopup');
				setCookie('promoPopup2024', 1, 1);
			}, 1000);
		}
	}

	promoPopup();


});
